import { CanceledStatuses, UnpaidStatuses } from '../../Model/Subscription';

/**
 * Reasons a coach/admin/AC cannot reply to a client in chat.
 * Each reason hides the message input and shows an explanatory banner instead.
 */
const ReplyBlockReason = {
  CANCELED: 'CANCELED',
  UNPAID: 'UNPAID',
  PAUSED: 'PAUSED',
};

/**
 * Resolve why the current viewer cannot reply in a channel.
 * Clients are never blocked - only coaches, admins and ACs looking at a client whose
 * subscription is canceled, unpaid or paused.
 * @param {object} options
 * @param {boolean} options.isCoachOrAdmin Whether the viewer is a coach or an admin (ACs are admins).
 * @param {object} options.clientUserDoc The user doc of the client the channel belongs to.
 * @param {object} options.coachDoc The doc of the coach that owns the channel.
 * @returns {string|null} The matching ReplyBlockReason, or null when replying is possible.
 */
const getReplyBlockReason = ({ isCoachOrAdmin, clientUserDoc, coachDoc }) => {
  if (!isCoachOrAdmin || !clientUserDoc) {
    return null;
  }

  if (CanceledStatuses.includes(clientUserDoc.subscriptionStatus)) {
    return ReplyBlockReason.CANCELED;
  }

  if (!coachDoc?.isACEnabled) {
    return null;
  }

  if (UnpaidStatuses.includes(clientUserDoc.subscriptionStatus)) {
    return ReplyBlockReason.UNPAID;
  }

  if (clientUserDoc.isOnBreakForAllProducts && !clientUserDoc.isFutureStartForAllProducts) {
    return ReplyBlockReason.PAUSED;
  }

  return null;
};

export {
  ReplyBlockReason,
  getReplyBlockReason,
};
